module.exports = __webpack_public_path__ + "img/starthot.5d372952.gif";